<app-menu-template3>
  <main class="container-fluid ">
    <article class="row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
      <section class="col-3 border-right p-4 mt-4 mb-5">
        <header class="text-center mb-3">
          <label class="h5">Filtra tu consulta</label>
        </header>
        <form [formGroup]="formFiltroNotificacion" (ngSubmit)="onFiltrar()">
          <div class="form-group">
            <label class="small text-secondary" for="estado">Tipo anotación</label>
            <select id="estado" formControlName="tipo_anotacion_id" class="form-control custom-select">
              <option value="">Seleccione</option>
              <ng-container *ngFor="let item of tipos_anotacion">
                <option [ngValue]="item.tipo_anotacion_id">{{item.descripcion}}</option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="estado">Tipo solicitud</label>
            <select id="estado" formControlName="tipo_solicitud_id" class="form-control custom-select">
              <option value="">Seleccione</option>
              <ng-container *ngFor="let item of tipos_solicitud">
                <option [ngValue]="item.tipo_solicitud_id">{{item.descripcion}}</option>
              </ng-container>
            </select>
          </div>
          <!-- <div class="form-group">
            <label class="small text-secondary mb-0">Tipo de notificación</label>
            <input formControlName="tipo_notificacion" type="text" class="form-control form-control-sm">
          </div> -->
          <!-- <div class="form-group">
            <label class="small text-secondary mb-0">Descripción de la notificación</label>
            <input formControlName="asunto" type="text" class="form-control form-control-sm">
          </div> -->
          <div class="form-group">
            <label class="text-secondary small mb-0">Fecha de envío</label>
            <div class="input-group">
              <input class="form-control form-control-sm" formControlName="fecha_creacion" placeholder="yyyy/mm/dd"
                ngbDatepicker #fin="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()" type="button"></button>
              </div>
            </div>
          </div>
          <!-- <div class="form-group">
            <label class="small text-secondary mb-0">Estado</label>
            <input formControlName="estado" type="text" class="form-control form-control-sm">
          </div> -->
          <div class="form-row mt-3">
            <button type="reset" class="btn btn-outline-primary border-0 m-auto" (click)="reset()">Limpiar</button>
            <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
          </div>
        </form>
      </section>
      <section class="col-9 p-4 mt-3 mb-5">
        <header class="row form-group d-flex align-items-center">
          <figure class="m-auto">
            <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
              height="60">
          </figure>
          <div class="col row">
            <label class="text-dark h5 mb-0 font-weight-bold">Lista de anotaciones relacionadas con el
              {{datoSolicitudSharedModel.data.descripcion_tipo_rnt.toLowerCase()}}</label>
            <div class="pl-0 col-12">
              <p *ngIf="datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles"
                class="text-dark h5 mb-0 font-weight-bold">{{establecimiento.direccion_comercial}},
                {{establecimiento.departamento}}, {{establecimiento.municipio}}</p>
              <p *ngIf="datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento"
                class="text-dark h5 mb-0 font-weight-bold">{{datoSolicitudSharedModel.data.razon_social}}</p>
              <p *ngIf="datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia" class="text-dark h5 mb-0 font-weight-bold">
                {{establecimiento.direccion_comercial}},
                {{establecimiento.departamento}}, {{establecimiento.municipio}}</p>
            </div>
          </div>
        </header>
        <div class="table-responsive">
          <app-tablas [page]="paginaActual" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
            [headers]="headers">
            <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
              <td>{{item.fecha_creacion | date:'d/MMM/yyyy, h:mm a' }}</td>
              <td>{{item.numero_radicacion}}</td>
              <td>{{item.desc_tipo_solicitud}}</td>
              <td>{{item.desc_tipo_anotacion}}</td>
              <td [innerHTML]="item.desc_anotacion"></td>
              <td>
                <span *ngIf="item.desc_tipo_usuario === 'PRESTADOR'">Prestador:</span>
                <span *ngIf="item.desc_tipo_usuario === 'FUNCIONARIO'">Funcionario:</span>
                <span *ngIf="item.desc_tipo_usuario === 'ADMINSITRADOR CAMARA DE COMERCIO'">Admin CC:</span>
                <span *ngIf="item.desc_tipo_usuario === 'USUARIO DEPOSITARIO PROVISIONAL'">Depositario:</span>
                {{item.usuario_creacion}}
              </td>
              <td>{{item.causal_devolucion}}</td>
            </tr>
          </app-tablas>
        </div>
      </section>
      <ng-template #no_data>
        <section class="col-9 p-4 mt-5 mb-5">
          <header class="col-12">
            <figure class="figure w-100">
              <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
              <figcaption>
                <label class="h3">Aún no tienes notificaciones</label>
              </figcaption>
            </figure>
          </header>
        </section>
      </ng-template>
    </article>
  </main>
</app-menu-template3>